import { LoggingHandler } from '../errorReporting/LoggingHandler';
// Base64 encode value
function encodeString(string: string) {
    return window.btoa(string);
}

// Validate if a string is Base64 encoded
function isBase64Encoded(string: string): boolean {
    try {
        return btoa(atob(string)) === string;
    } catch (e) {
        return false;
    }
}

// Decode base64 encodedValue
function decodeString(encodedString: string) {
    if (isBase64Encoded(encodedString)) {
        return window.atob(encodedString);
    } else {
        LoggingHandler().logError(
            'Decoding Error: Input is not a valid Base64-encoded string',
            {
                searchTerm: 'decoding-error',
                fileName: 'encoding.ts',
                tags: ['forms', 'cookies'],
                additionalData: { input: encodedString },
            }
        );
        return null;
    }
}

export { encodeString, decodeString };
